import { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { loadConfig } from '../services/config';
import api from "../services/api";
import { format } from 'date-fns';
import "../assets/js/confetti.js";
import { io } from "socket.io-client";
import countries from "./countries";
import minimum_amount_per_currency from "./minimum_amount_per_currency";
import { messaging } from "../firebase";
import { getToken, onMessage } from "firebase/messaging";

let ENV = "staging";
let SOCKET_URL_BUYER_ORDER_DATA = "https://announcement-566838971647.asia-southeast1.run.app";
if (window.location.hostname.includes('supercheckout.ai') && window.location.hostname.includes('pay-sandbox-')){
  ENV = "sandbox";
  let region_code = "";
  if(window.location.hostname.includes('pay-sandbox-us')){
    region_code = "us";
  }
  else if(window.location.hostname.includes('pay-sandbox-sg')){
    region_code = "sg";
  }
  else if(window.location.hostname.includes('pay-sandbox-in')){
    region_code = "in";
  }
  SOCKET_URL_BUYER_ORDER_DATA = "https://api-sandbox-"+ region_code +".supercheckout.dev";
}
else if (window.location.hostname.includes('supercheckout.ai')){
  ENV = "production";
  let region_code = "";
  if(window.location.hostname.includes('pay-us')){
    region_code = "us";
  }
  else if(window.location.hostname.includes('pay-sg')){
    region_code = "sg";
  }
  else if(window.location.hostname.includes('pay-in')){
    region_code = "in";
  }
  SOCKET_URL_BUYER_ORDER_DATA = "https://api-"+ region_code +".supercheckout.dev";
}

const socket = io(`${SOCKET_URL_BUYER_ORDER_DATA}`, {
  transports: ["websocket"],
  path: ENV === 'staging' ? "/socket.io" : "/notify/socket.io"
});

const new_activity_sound = new Audio("/new-activity.mp3");
const pool_completion_sound = new Audio("/pool-completion.mp3");

let name_from_localstorage = localStorage.getItem("username");
if(name_from_localstorage === null){
  name_from_localstorage = "";
}

export const requestForToken = async (id, shop) => {
  const appConfig = await loadConfig();

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: appConfig.FCM_VAPID_ID,
    });

    if (currentToken) {
      console.log("FCM Token:", currentToken);

      const previouslySentToken = localStorage.getItem("sc_pn_fcmTokenSent");

      if (previouslySentToken !== currentToken) {
        let requestData = {
          token: currentToken,
          order_id: id,
          shopname: shop,
          //shopname: "SuperCheckout",
          active: true,
          name: "User"
        };
        
        let response = await api.post(`${appConfig.announcementApiBaseUrl}register-token`, requestData);
        console.log(response);
  
        if ( [200, 201].includes(response?.status) && response?.data ) {
          localStorage.setItem("sc_pn_fcmTokenSent", currentToken);

          console.log(response.data);
        } else {
          console.log(response.data.errorMessage);
        }
      } else {
        console.log("Token already registered on backend, skipping...");
      }
    } else {
      console.log("No registration token available. Request permission to generate one.");
    }
  } catch (error) {
    console.error("An error occurred while retrieving token. ", error);
  }
};

export const onMessageListener = () => new Promise((resolve) => {
  onMessage(messaging, (payload) => {
    resolve(payload);
  });
});

const useGlobalState = (id, pageName) => {
  const [confetti_play_count, set_confetti_play_count] = useState(0);
  const [confetti_play_init_bool, set_confetti_play_init_bool] = useState(false);
  const [poolProgressBarPercent, setPoolProgressBarPercent] = useState(0);
  const [amountPaidSoFar, setAmountPaidSoFar] = useState(0.00);
  const [amountLeft, setAmountLeft] = useState(0.00);
  const [noOfSplitPaymentsDone, setNoOfSplitPaymentsDone] = useState(0);
  const [getListActivitiesResult, set_getListActivitiesResult] = useState([]);
  const [cartItemsPaidAlready, set_cartItemsPaidAlready] = useState([]);
  const [isOrderTimeSensitive, set_isOrderTimeSensitive] = useState(false);
  const [orderTimedOut, set_orderTimedOut] = useState(false);
  const [order_type, set_order_type] = useState('');
  const [this_orderIsRefundedBool, set_this_orderIsRefundedBool] = useState(false);
  const [recentmostSingleOrderActivityStatus, set_recentmostSingleOrderActivityStatus] = useState('');
  const shopifyOrderAddShippingInfoStageDone = useRef(false);

  const [searchParams] = useSearchParams();
  const redirect_status = searchParams.get("redirect_status");
  const [superpay, set_superpay] = useState(searchParams.get("superpay"));

  const [name, setName] = useState(name_from_localstorage);
  const [oboName, setOboName] = useState("");

  let initial_screenName = "";
  if(pageName === 'sdk-checkout-init'){
    initial_screenName = "cart_view";
  }
  else if(pageName === 'shopify-payment'){
    //initial_screenName = "no_of_pax";
    //initial_screenName = "activity";
    initial_screenName = "payment";
  }
  else if(pageName === 'shopify-payment-shared'){
    initial_screenName = "activity";
  }
  else if(pageName === 'stripe-payment' || pageName === 'square-payment' || pageName === 'razorpay-payment' || pageName === 'xendit-payment' || pageName === 'payu-payment' || pageName === 'reddot-payment' || pageName === 'adyen-payment' || pageName === 'airwallex-payment' || pageName === 'tyro-payment' || pageName === 'nets-payment'){
    if(redirect_status === 'succeeded' || redirect_status === 'requires_capture'){
      initial_screenName = "payment_success";
    }
    else{
      initial_screenName = "payment";
    }
  }

  const [screenName, setScreenName] = useState(initial_screenName);

  let inital_step = 0;
  if(redirect_status === 'succeeded' || redirect_status === 'requires_capture' || redirect_status === 'payment_success'){
    inital_step = 2;
  }
  else if((name_from_localstorage !== null && name_from_localstorage !== '') || pageName === 'shopify-payment'){
    inital_step = 2;
  }

  const [step, setStep] = useState(inital_step);

  //confetti start
  useEffect(() => {
    if (!confetti_play_init_bool) return;
    if (confetti_play_count >= 10) return;

    const interval = setInterval(() => {
      window.manager.addConfetti();
      
      set_confetti_play_count((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, [confetti_play_init_bool, confetti_play_count]);
  //confetti end

  //socket code to get live activities - start
  useEffect(() => {
    if (!id) return;

    if (!socket) return;

    const handler = (data) => {
      console.log(data);

      set_recentmostSingleOrderActivityStatus(data.order_status);

      if(data.order_status !== 'initiated' && data.order_status !== 'expired'){
        if(data.order_status === 'authorized'){
          new_activity_sound.play();
          setNoOfSplitPaymentsDone((prev) => prev + 1);

          if(pageName === 'shopify-payment'){
            /* if(shopifyPaymentTabRef.current) {
              shopifyPaymentTabRef.current.close();
              shopifyPaymentTabRef.current = null;
            } */

            shopifyOrderAddShippingInfoStageDone.current = true;
          }

          if(pageName === 'sdk-checkout-init'){
            for(var j=0; j < data.items_status.event_list.length; j++){
              data.items_status.event_list[j]['user_name'] = data.user_name;
            }
            
            if(cartItemsPaidAlready.length === 0){
              set_cartItemsPaidAlready(data.items_status.event_list);
            }
            else{
              set_cartItemsPaidAlready((prev) => [data.items_status.event_list, ...prev]);
            }
          }
        }

        if(typeof data.amount_so_far !== 'undefined' && data.amount_so_far !== null && data.amount_so_far !== ''){
          setAmountPaidSoFar(parseFloat(data.amount_so_far).toFixed(2));

          let amount_left = parseFloat(data.total_amount) - parseFloat(data.amount_so_far);
          setAmountLeft(parseFloat(amount_left).toFixed(2));
          
          let percentage_done = 0;
          percentage_done = (parseFloat(data.amount_so_far) / parseFloat(data.total_amount)) * 100;
          if(percentage_done > 100){
            percentage_done = 100;
          }
          setPoolProgressBarPercent(percentage_done.toFixed(2));

          if(percentage_done === 100){
            setScreenName("pool_completed");

            if(data.order_status !== 'refunded'){
              pool_completion_sound.play();
              window.manager.addConfetti();
              set_confetti_play_init_bool(true);
            }
          }
          else{
            if(pageName === 'sdk-checkout-init'){
              setScreenName("order_in_progress_already");
            }
            else if(pageName === 'shopify-payment'){
              console.log("payment_success global page");
              if(screenName === 'activity' || screenName === 'payment_success'){
                console.log("payment_success global if case");
                setScreenName("payment_success");
              }
              else if(data.user_id === localStorage.getItem("payment_link__"+ id)){
                console.log("payment_success global else if case");
                setScreenName("payment_success");
              }
              else{
                console.log("payment_success global else case");
                setScreenName("payment");
              }
            }
            else if(pageName === 'nets-payment'){
              if(screenName === 'activity' || screenName === 'payment_success'){
                console.log("payment_success global if case");
                setScreenName("payment_success");
                setStep(2);
                
                setOboName("");
              }
              else if(data.user_id === localStorage.getItem("payment_link__"+ id)){
                console.log("payment_success global else if case");
                
                setScreenName("payment_success");
                setStep(2);
                
                setOboName("");
              }
              else{
                console.log("payment_success global else case");
                
                setScreenName("payment");
              }
            }
          }
        }
      }
      else if(data.order_status === 'expired'){
        new_activity_sound.play();

        setScreenName("payment");
      }

      if(data.order_status === 'refunded'){
        set_this_orderIsRefundedBool(true);
      }

      set_getListActivitiesResult((prev) => [data, ...prev]);
    };
  
    socket.on(id, handler);
  
    return () => {
      socket.off(id, handler);
    };
  }, [id]);
  //socket code to get live activities - end

  useEffect(() => {
    if(typeof screenName !== 'undefined' && screenName === 'pool_completed'){
      localStorage.removeItem("sc_pn_fcmTokenSent");
      localStorage.removeItem("payment_link__"+ id);
      localStorage.removeItem("total_pax__"+ id);

      if(document.getElementById('orderTimeoutContainer')){
        document.getElementById('orderTimeoutContainer').style.display = 'none';
      }
      document.documentElement.classList.add('activeScreenName_pool_completed');
    }
  }, [screenName]);

  return { new_activity_sound, pool_completion_sound, confetti_play_count, set_confetti_play_count, confetti_play_init_bool, set_confetti_play_init_bool, poolProgressBarPercent, setPoolProgressBarPercent, getListActivitiesResult, set_getListActivitiesResult, screenName, setScreenName, amountPaidSoFar, setAmountPaidSoFar, amountLeft, setAmountLeft, noOfSplitPaymentsDone, setNoOfSplitPaymentsDone, cartItemsPaidAlready, set_cartItemsPaidAlready, isOrderTimeSensitive, set_isOrderTimeSensitive, orderTimedOut, set_orderTimedOut, name, setName, step, setStep, order_type, set_order_type, oboName, setOboName, superpay, set_superpay, this_orderIsRefundedBool, set_this_orderIsRefundedBool, recentmostSingleOrderActivityStatus, set_recentmostSingleOrderActivityStatus, shopifyOrderAddShippingInfoStageDone };
};
export default useGlobalState;

export const fetchShopDetailsByShopLink = async (urlShopLink) => {
  try {
    let response = await api.get(`sdk/orders/user-by-shop-link/${urlShopLink}`);
    console.log(response);

    enableBootstrapTooltip();

    if ( [200, 201].includes(response?.status) && response?.data ) {
      response.data.data['currency_with_symbol'] = getCurrencySymbol(response.data.data.user_currency);

      if(response.data.data.meta_data === null){
        //setting default meta_data
        response.data.data.meta_data = {
          fixed_price: true,
          variable_price: true,
          timeout: null
        };
      }

      return response.data.data;
    } else {
      if ( response?.data?.errorMessage && response?.data?.errorMessage?.length ) {
        //toaster.error(response.data.errorMessage);
      } else {
        //toaster.error("Something went wrong");
      }

      return response.data;
    }
  } catch (error) {
    window.location.href = "/404";
    console.log("Exception: ", error);

    //toaster.error(`Something went wrong while fetching details for the shop "${shopLink}"`);

    return error;
  }
}

export const getOrderStatusApiCall = async (id) => {
  try {
    let getOrderStatusApiCallResponse = await api.get(
      `sdk/orders/get-order-status/${id}`
    );
    console.log(getOrderStatusApiCallResponse);

    return getOrderStatusApiCallResponse.data;
  } catch (error) {
    console.log("Exception: ", error);

    //toaster.error("Something went wrong");

    return error;
  }
};

export const getListActivitiesApiCall = async (id) => {
  try {
    let getListActivitiesApiCallResponse = await api.get(
      `sdk/orders/list-activities/${id}`
    );
    console.log(getListActivitiesApiCallResponse);

    enableBootstrapTooltip();

    return getListActivitiesApiCallResponse.data;
  } catch (error) {
    console.log("Exception: ", error);

    //toaster.error("Something went wrong");

    return error;
  }
};

export const enableBootstrapTooltip = () => {
  setTimeout(function(){
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));
  }, 100);
}

export const getShopLinkFromUlr = () => {
  const path = window.location.pathname;
  const country = path.split('/')[1];
  return country;
}

export const getCountryCodeFromUlr = () => {
  const path = window.location.pathname;
  const country = path.split('/')[1];
  return country;
}

export const getCountryCode = () => {
  const countryCode = getCountryCodeFromUlr();
  return countryCode;
}

export const poolMoneyAgainForSomeone_extended = (id, checkoutMethod) => {
  localStorage.removeItem("username");

  name_from_localstorage = "";

  localStorage.removeItem("payment_link__"+ id);

  if(checkoutMethod === 'cart_based'){
    window.location.href = window.location.origin +"/checkout/"+ id;
  }
  else{
    let link_url = window.location.href;
    if(link_url.indexOf('redirect_status') > -1){
      link_url = link_url.replace('redirect_status','r_s');
    }

    window.location.href = link_url;
  }
}

export const goBackToEditNameScreen_extended = (id) => {
  localStorage.removeItem("username");

  name_from_localstorage = "";

  localStorage.removeItem("payment_link__"+ id);
}

export const navigateToPage = (navigateTo) => {
  let userDeatils  = localStorage.getItem("pool_user_details");
  try {
    userDeatils = JSON.parse(userDeatils);
    if(userDeatils.country) {
      let country = userDeatils.country.toLowerCase();
      window.location.href = `/${country}/${navigateTo}`;
    } else if(["", "/"].includes(navigateTo)) {
      window.location.href = `/`;
    } else {
      window.location.href = `/${navigateTo}`;
    }
  } catch (error) {
    console.error(error)
  }
}

export const formatDateTime = (dateString, dateFormat = "MM/dd/yy h:mm a") => {
  return format("2025-02-04T18:43:22.179578Z", dateFormat); 
}

export const getInitialsOfUserName = (fullName) => {
  if(typeof fullName !== 'undefined'){
    if(fullName.indexOf(' ') > -1){
      fullName = fullName.split(' ');

      var fname = fullName[0];
      var lname = fullName[1];

      return fname.charAt(0) +""+ lname.charAt(0);
    }
    else{
      return fullName.charAt(0) +""+ fullName.charAt(1);
    }
  }
}

export const isLetter = (str) => {
  //will return null if not from a-z
  return str.length === 1 && str.match(/[a-z]/i);
}

export const getCurrencySymbol = (input_currency) => {
  if(input_currency !== '' && typeof input_currency !== 'undefined'){
    input_currency = input_currency.toUpperCase();
    let lastChar = input_currency.slice(-1);
    
    for(var i=0; i < countries.length; i++){
      if(countries[i].currency === input_currency.toUpperCase()){
        lastChar = countries[i].currency_with_symbol.slice(-1);
        
        if(isLetter(lastChar) === null){
          if(input_currency === 'Rp'){
            return countries[i].currency_with_symbol +" ";
          }
          else{
            return countries[i].currency_with_symbol;
          }
        }
        else{
          return countries[i].currency_with_symbol +" ";
        }
      }
    }
  }
}

export const formatAmountInLocale = (currency, amount) => {
  if(typeof amount !== 'undefined'){
    currency = currency.toUpperCase();
    amount = parseFloat(amount);
    amount = amount.toFixed(2);

    let this_locale = countries.find((elm) => elm.currency.toUpperCase() === currency);

    const zeroDecimalCurrencies = ['BIF', 'CLP', 'DJF', 'GNF', 'ISK', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'UYI', 'VND', 'VUV', 'XAF', 'XOF', 'XPF', 'IDR', 'MMK', 'KPW'];

    if(zeroDecimalCurrencies.indexOf(currency) > -1){
      return Number(amount).toLocaleString(this_locale.locale);
    }
    else{
      let final_amount = Number(amount).toLocaleString(this_locale.locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      //return parseFloat(final_amount).toFixed(2); //this will create issue for INR
      return final_amount;
    }
  }
}

export const getMinimumAmountForCurrency = (currency) => {
  if(typeof currency !== 'undefined'){
    return minimum_amount_per_currency[currency.toUpperCase()] ?? null;
  }
}

export const returnShortCodeOfPaymentMethod = (pg_name) => {
  if(typeof pg_name !== 'undefined'){
    if(pg_name === 'stripe'){
      return "str";
    }
    else if(pg_name === 'razorpay'){
      return "rzp";
    }
    else if(pg_name === 'xendit'){
      return "xnd";
    }
    else if(pg_name === 'payu'){
      return "pyu";
    }
    else if(pg_name === 'adyen'){
      return "adn";
    }
    else if(pg_name === 'airwallex'){
      return "awx";
    }
    else if(pg_name === 'tyro'){
      return "tyr";
    }
    else if(pg_name === 'nets'){
      return "nts";
    }
    else if(pg_name === 'reddot'){
      return "rdp";
    }
    else if(pg_name === 'square'){
      return "sqr";
    }
    else if(pg_name === 'shopify'){
      return "spf";
    }
  }
}

export const logErrorToGoogleSheet = ({ message, stack, type }) => {
  let ENV = "staging";
  if (window.location.hostname.includes('supercheckout.ai') && window.location.hostname.includes('pay-sandbox-')){
    ENV = "sandbox";
  }
  else if (window.location.hostname.includes('supercheckout.ai')){
    ENV = "production";
  }

  fetch("https://script.google.com/macros/s/AKfycbzJUawfxNWwRk9sYFGJBwkoUGB9pf9FSX3YpJFUmounkffMO5fnGLdB8L99ldwNcoc/exec", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      env: ENV,
      message,
      stack,
      type,
      url: window.location.href,
      userAgent: navigator.userAgent,
    }),
  }).then((res) => res.text())
  .then((text) => console.log("✅ Logged to sheet:", text))
  .catch((e) => console.log("❌ Error logging failed", e));
}

//Capture runtime JS errors
window.onerror = function (message, source, lineno, colno, error) {
  logErrorToGoogleSheet({
    message,
    stack: error?.stack || `${source}:${lineno}:${colno}`,
    type: "window.onerror",
  });
};

//Capture unhandled Promise rejections
window.onunhandledrejection = function (event) {
  logErrorToGoogleSheet({
    message: event.reason?.message || "Unhandled Rejection",
    stack: event.reason?.stack || "",
    type: "window.onunhandledrejection",
  });
};

export const getFormattedFullOrderTimeLeft = (orderCreatedAt, timeoutMinutes) => {
  if(typeof orderCreatedAt !== 'undefined' && typeof timeoutMinutes !== 'undefined' && orderCreatedAt !== '' && timeoutMinutes !== ''){
    const now = new Date();
    const expiryTime = new Date(new Date(orderCreatedAt).getTime() + timeoutMinutes * 60 * 1000);
    const diff = Math.floor((expiryTime - now) / 1000); // in seconds
    const clamped = diff > 0 ? diff : 0;

    const hours = Math.floor(clamped / 3600);
    const minutes = Math.floor((clamped % 3600) / 60);
    const seconds = clamped % 60;

    return (hours > 0 ? String(hours).padStart(2, "0") + ":" : "") +
          String(minutes).padStart(2, "0") + ":" +
          String(seconds).padStart(2, "0");
  }
};